import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../../../contexts/AuthContext";

const Redirect = () => {
  useEffect(() => {
    verifyUser();
  }, []);

  const navigate = useNavigate();

  const { userLoggedData } = useContext(AuthContext);

  console.log("userLoggedData", userLoggedData);

  const verifyUser = async () => {
    if (!userLoggedData) {
      return navigate("/login");
    } else if (userLoggedData.role.toUpperCase() === "ADMIN") {
      return navigate("/private/admin/dashboard");
    } else if (userLoggedData.role.toUpperCase() === "PLAYER") {
      return navigate("/private/user/home");
    } else {
      return navigate("/user/error");
    }
  };

  return <div>Redirecionando...</div>;
};

export default Redirect;
